import { breakpoints } from "@asurion-core/mx-asurion-ui-react";
import styled from "styled-components";

export const FlexContactWrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;

  ${breakpoints.lg} {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }
`;

export const FlexNameWrapperContainer = styled(FlexContactWrapperContainer)`
  ${breakpoints.md2} {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
`;

export const StyledLoader = styled.div<{ height?: number }>`
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${({ height }) => (height ? `${height}%` : `100%`)};
  align-items: center;
`;
